import { TipDetail } from '@core/models';
import { FixedTipStrategy } from './strategies/fixed-tip.strategy';
import { PercentageTipStrategy } from './strategies/percentage-tip.strategy';
import { TipCalculationStrategy } from './interfaces/tip-calculation-strategy.interface';

export class TipCalculationFactory {
	private readonly fixedTipStrategy = new FixedTipStrategy();
	private readonly percentageTipStrategy = new PercentageTipStrategy();

	create(tip: TipDetail): TipCalculationStrategy {
		if (tip.esPorcentual === false || (tip.isCustom && !!tip.value)) {
			return this.fixedTipStrategy;
		}

		return this.percentageTipStrategy;
	}
}
